<template>
  <div class="editorial-site">
    <NavBarMobileMenu v-if="showMenu" @close:menu="showMenu = false" />
    <NavBar :menu-open="showMenu" @open:menu="showMenu = true" />
    <main id="main-content" class="editorial-container" tabindex="-1"><slot /></main>
    <Footer />
  </div>
</template>
<script setup lang="ts">
const showMenu = ref(false)
</script>
